// src/pages/Home.jsx
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom"; // ← ADDED
import Navbar from "../components/Navbar";
import BestSeller from "./BestSeller";
import NewArrivals from "./NewArrivals";
import Reviews from "../components/Reviews";

const Home = () => {
  const [heroes, setHeroes] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  // FETCH HERO SLIDES
 useEffect(() => {
  const fetchHeroes = async () => {
    try {
      setLoading(true); // optional: reset loading if needed

      const response = await fetch('/api/heroes/');

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      console.log(response);
      const data = await response.json();
      setHeroes(data);
      console.log(data);
    } catch (err) {
      console.error("Error fetching heroes:", err);
      // Optional: show error to user
      // setError("Failed to load hero slides");
    } finally {
      setLoading(false);
    }
  };

  fetchHeroes();
}, []);

  // AUTO SLIDE
  useEffect(() => {
    if (heroes.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % heroes.length);
      }, 6000);
      return () => clearInterval(interval);
    }
  }, [heroes.length]);

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % heroes.length);
  const prevSlide = () =>
    setCurrentIndex((prev) => (prev - 1 + heroes.length) % heroes.length);

  if (loading) {
    return (
      <div className="h-screen bg-black flex items-center justify-center">
        <div className="text-white text-4xl font-light">Loading Magic...</div>
      </div>
    );
  }

  if (heroes.length === 0) {
    return (
      <div className="text-center py-32 text-2xl text-gray-600">
        No hero slides in admin!
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f7f7f7]">
      <Navbar />

      {/* LUXURY HERO SLIDER */}
      <section className="relative h-screen overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ scale: 1.1, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="absolute inset-0"
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url(${heroes[currentIndex]?.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* CONTENT */}
            <div className="h-full flex items-center justify-center px-6">
              <motion.div
                initial="hidden"
                animate="visible"
                variants={{
                  hidden: { opacity: 0 },
                  visible: {
                    opacity: 1,
                    transition: {
                      staggerChildren: 0.3,
                      delayChildren: 0.4,
                    },
                  },
                }}
                className="text-center max-w-5xl"
              >
                {/* TITLE */}
                <motion.h1
                  variants={{
                    hidden: { y: 60, opacity: 0 },
                    visible: { y: 0, opacity: 1 },
                  }}
                  transition={{ duration: 1, ease: "easeOut" }}
                  className="text-5xl md:text-8xl font-extralight text-white mb-6 tracking-widest"
                  style={{ fontFamily: "'Raleway', sans-serif" }}
                >
                  {heroes[currentIndex]?.title}
                </motion.h1>

                {/* SUBTITLE */}
                <motion.p
                  variants={{
                    hidden: { y: 40, opacity: 0 },
                    visible: { y: 0, opacity: 1 },
                  }}
                  transition={{ duration: 1, ease: "easeOut" }}
                  className="text-xl md:text-3xl text-white/90 mb-12 max-w-3xl mx-auto font-light"
                >
                  {heroes[currentIndex]?.subtitle}
                </motion.p>

                {/* BUTTON – NOW USING <Link> */}
                <motion.div
                  variants={{
                    hidden: { y: 50, opacity: 0, scale: 0.8 },
                    visible: { y: 0, opacity: 1, scale: 1 },
                  }}
                  transition={{ duration: 0.8, ease: "backOut" }}
                >
                  <Link
                    to={heroes[currentIndex]?.button_link || "/collections"}
                    className="inline-block bg-white text-black px-14 py-5 rounded-full text-lg font-semibold hover:bg-gray-100 transition shadow-2xl"
                  >
                    {heroes[currentIndex]?.button_text || "Shop Now"}
                  </Link>
                </motion.div>
              </motion.div>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* NAVIGATION ARROWS */}
        {heroes.length > 1 && (
          <>
            <button
              onClick={prevSlide}
              className="absolute left-8 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/30 backdrop-blur-md text-white p-4 rounded-full transition z-30 border border-white/20"
              aria-label="Previous slide"
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            <button
              onClick={nextSlide}
              className="absolute right-8 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/30 backdrop-blur-md text-white p-4 rounded-full transition z-30 border border-white/20"
              aria-label="Next slide"
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </>
        )}

        {/* DOTS INDICATOR */}
        {heroes.length > 1 && (
          <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-3 z-30">
            {heroes.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`transition-all duration-300 ${
                  index === currentIndex
                    ? "bg-white w-12 h-3 rounded-full"
                    : "bg-white/40 w-3 h-3 rounded-full hover:bg-white/70"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* SLIDE COUNTER */}
        {heroes.length > 1 && (
          <div className="absolute top-10 right-10 text-white/70 font-light text-sm tracking-wider z-30">
            0{currentIndex + 1} / 0{heroes.length}
          </div>
        )}
      </section>

      {/* OTHER SECTIONS */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <BestSeller />
        </div>
      </section>

      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <NewArrivals />
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <Reviews />
        </div>
      </section>
    </div>
  );
};

export default Home;
